import { z } from 'zod'

import { validTimestampSchema } from './conversations-contracts'

export const conversationOwnershipStateSchema = z
  .object({
    schemaVersion: z.literal(1),
    aggregateId: z.string().regex(/^ia_v1_[0-9a-f]{64}$/),
    ownershipState: z.enum(['AI_ACTIVE', 'HUMAN_TAKEOVER']),
    revision: z.number().int().nonnegative(),
    updatedAtMs: validTimestampSchema.nullable(),
    updatedByFingerprint: z.string().length(64).nullable(),
    ownershipSinceMs: validTimestampSchema.nullable(),
    integrityFingerprint: z.string().length(64),
  })
  .strict()

export const conversationOwnershipCommandSchema =
  conversationOwnershipStateSchema.extend({
    replayClassification: z.enum(['APPLIED', 'EXACT_REPLAY']),
  })

export const staffSmsCommandResultSchema = z
  .object({
    schemaVersion: z.literal(1),
    aggregateId: z.string().regex(/^ia_v1_[0-9a-f]{64}$/),
    messageId: z.string().regex(/^staff_sms_v1_[0-9a-f]{64}$/),
    dispatchState: z.enum([
      'ACCEPTED',
      'DISPATCHING',
      'SENT',
      'FAILED_TERMINAL',
      'RECONCILIATION_REQUIRED',
    ]),
    ownershipRevision: z.number().int().positive(),
  })
  .strict()

export const conversationSmsRouteSchema = z
  .object({
    schemaVersion: z.literal(1),
    aggregateId: z.string().regex(/^ia_v1_[0-9a-f]{64}$/),
    routeRef: z.string().regex(/^sms_route_v1_[0-9a-f]{64}$/),
    routeRevision: z.number().int().positive(),
    sourceActivityAtMs: validTimestampSchema,
    smsCapable: z.literal(true),
  })
  .strict()

export const conversationCommandErrorSchema = z
  .object({
    message: z.enum([
      'OWNERSHIP_CONFLICT',
      'OPTED_OUT',
      'SMS_NOT_AVAILABLE',
      'SMS_ROUTE_NOT_AVAILABLE',
      'SMS_ROUTE_CONFLICT',
      'ROUTING_NOT_READY',
      'AMBIGUOUS_THREAD',
      'IDEMPOTENCY_CONFLICT',
      'INVALID_MESSAGE',
      'RECONCILIATION_REQUIRED',
      'SERVICE_UNAVAILABLE',
    ]),
  })
  .strict()

export type ConversationOwnershipState = z.infer<
  typeof conversationOwnershipStateSchema
>

export type ConversationSmsRoute = z.infer<typeof conversationSmsRouteSchema>
